import { render, staticRenderFns } from "./OldCabinetDialog.vue?vue&type=template&id=2d6f48ef"
import script from "./OldCabinetDialog.vue?vue&type=script&lang=js"
export * from "./OldCabinetDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports